export default "__VITE_ASSET__95727c2b__"